export class StringUtil {
  escapeSpecials(text: string): string {
    const pattern = "\\\\";
    const regexp = new RegExp("[" + pattern + "]", "g");
    return text.replace(regexp, "");
  }

  normalizeAndRemoveUnimportantChars(text: string): string {
    return text
        .toLowerCase()
        /*                                                                             */
        .replace(/["{}]/g, "")
  }

  compareIgnoreCase(textA: string, textB: string): boolean {
    if (textA == undefined || textB == undefined) {
      return textA == undefined && textB == undefined;
    }

    const normalizedTextA = this.normalizeAndRemoveUnimportantChars(textA);
    const normalizedTextB = this.normalizeAndRemoveUnimportantChars(textB);

    const decodedA = this.safeDecodeURIComponent(normalizedTextA);
    const decodedB = this.safeDecodeURIComponent(normalizedTextB);

    if (this.trim(decodedA) === this.trim(decodedB)) {
      return true;
    }

    /*                                                                                                              */
    const isbnA = this.toIsbn13(decodedA);
    return isbnA !== null && isbnA === this.toIsbn13(decodedB);
  }

  /*                                                                                                             */
  toIsbn13(text: string): string | null {
    const stripped = text.trim().toLowerCase().replace(/^isbn(-?1[03])?\s*:?\s*/, "");
    if (!/^[0-9x\- ]+$/.test(stripped)) return null;
    const compact = stripped.replace(/[- ]/g, "");
    const check13 = (first12: string) => {
      const sum = [...first12].reduce((acc, c, i) => acc + Number(c) * (i % 2 === 0 ? 1 : 3), 0);
      return String((10 - (sum % 10)) % 10);
    };
    if (/^97[89]\d{10}$/.test(compact)) {
      return check13(compact.slice(0, 12)) === compact[12] ? compact : null;
    }
    if (/^\d{9}[\dx]$/.test(compact)) {
      const sum = [...compact].reduce((acc, c, i) => acc + (c === "x" ? 10 : Number(c)) * (10 - i), 0);
      if (sum % 11 !== 0) return null;
      const first12 = "978" + compact.slice(0, 9);
      return first12 + check13(first12);
    }
    return null;
  }

  private safeDecodeURIComponent(text: string): string {
    try {
      return decodeURIComponent(text);
    } catch {
      return text;
    }
  }

  trimLeft(text: string): string {
    return text.replace(/^\s+/, "");
  }

  trimRight(text: string): string {
    return text.replace(/\s+$/, "");
  }

  trim(text: string): string {
    return text
      ?.trim()
      .split(/[\s,\t,\n]+/)
      .join(" ");
  }

  capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  unslugify(text: string): string {
    return text.replace(/ae/g, "ä").replace(/ue/g, "ü").replace(/oe/g, "ö").replace(/-/g, " ");
  }
}

export class GlobalUtil {
  setLocation(target: string) {
    (window as Window).location = target;
  }
}

export class CoreUtil {
  private value = 0;

  nextValue(): number {
    return ++this.value;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  counter(start?: number): CoreUtil["nextValue"] {
    return this.nextValue.bind({ value: (start || 1) - 1 });
  }
}

export interface Util {
  string: StringUtil;
  global: GlobalUtil;
  core: CoreUtil;
}

export const util = {
  string: new StringUtil(),
  global: new GlobalUtil(),
  core: new CoreUtil(),
};
